import { bind } from 'decko'
import Cookies from 'js-cookie'
import { LiveElement } from 'live-node-list'

export default class PromoBar {
  /**
   * @type {LiveElement}
   */
  promoBar = new LiveElement('.promo-bar')

  constructor() {
    this.registerListeners()

    this.promoBar.on('update', () => {
      this.registerListeners()
    })
  }

  @bind
  registerListeners() {
    if (!this.promoBar.item) {
      return
    }

    if (!Cookies.get('promo_bar')) {
      this.openPromoBar()
      this.closeButton = this.promoBar.item.querySelector('.promo-bar__close')
      if(this.closeButton) {
        this.closeButton.addEventListener('click', this.closePromoBar)
      }
    }
  }

  @bind
  openPromoBar() {
    this.promoBar.item.setAttribute('aria-hidden', 'false')
    this.promoBarItems = this.promoBar.item.querySelectorAll('.promo-bar__row')

    if (this.promoBarItems.length > 1) {
      let counter = 1

      const i = setInterval(() => {
        this.promoBarItems.forEach(item => {
          item.classList.remove('promo-bar__row--active')
        })
        this.promoBarItems[counter].classList.add('promo-bar__row--active')

        counter++;
        if (counter === this.promoBarItems.length) {
          counter = 0;
        }
      }, this.promoBar.item.dataset.rotationSpeed * 1000);
    }
  }

  @bind
  closePromoBar() {
    Cookies.set('promo_bar', true, { expires: 7 })
    this.promoBar.item.setAttribute('aria-hidden', 'true')
  }
}
